import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

const baseUrl = '/api/LienHolders';
const routes = {
  lienHoldersPathWithId: (id) => `${baseUrl}/${id}`,
  lienHoldersWithParams: (params) => `${baseUrl}${getQueryParams(params)}`,
  lienHoldersGridPath: (params) => `${baseUrl}/Grid${getQueryParams(params)}`,
  lienHoldersRestorePath: (id) => `${baseUrl}/${id}/restore`,
  lienHoldersAuditsPathById: (id, params) => `${baseUrl}/${id}/Audits${getQueryParams(params)}`,
  lienHoldersAuditPropertiesPathById: (id) => `${baseUrl}/${id}/Audits/Properties`,
  lienHoldersAuditUsersPathById: (id) => `${baseUrl}/${id}/Audits/Users`,
  lienHoldersLookup: (params) => `${baseUrl}/Lookup${getQueryParams(params)}`,
};

export const getLienHoldersGrid = (params) => makeRequest(authFetch.get(routes.lienHoldersGridPath(params)));
export const getLienHolders = () => makeRequest(authFetch.get(baseUrl));
export const getLienHolderById = (id) => makeRequest(authFetch.get(routes.lienHoldersPathWithId(id)));

export const upsertLienHolder = (data) => makeRequest(authFetch.put(baseUrl, data));

export const deleteLienHolder = (id) => makeRequest(authFetch.delete(routes.lienHoldersPathWithId(id)));
export const restoreLienHolder = (id) => makeRequest(authFetch.patch(routes.lienHoldersRestorePath(id)));

export const getlienHoldersAudits = (id, params) =>
  makeRequest(authFetch.get(routes.lienHoldersAuditsPathById(id, params)));
export const getlienHoldersAuditProperties = (id) =>
  makeRequest(authFetch.get(routes.lienHoldersAuditPropertiesPathById(id)));
export const getlienHoldersAuditUsers = (id) => makeRequest(authFetch.get(routes.lienHoldersAuditUsersPathById(id)));

export const getLienHoldersLookup = (params) => makeRequest(authFetch.get(routes.lienHoldersLookup(params)));